<script setup>
import NotesEditor from '~/terra/molecules/note-editor.vue';

const props = defineProps({
  handleSave: {
    type: Function,
    default: () => {},
  },
});

const emits = defineEmits(['close', 'submit']);
async function onSend(data) {
  await props.handleSave(data);
  emits('close');
}
</script>

<template>
  <hawk-modal-container>
    <hawk-modal-header @close="emits('close')">
      <template #title>
        {{ $t('Notes') }}
      </template>
    </hawk-modal-header>
    <hawk-modal-content>
      <NotesEditor
        class="!p-0"
        :on_send="onSend"
        :popup_editor="true"
      />
    </hawk-modal-content>
  </hawk-modal-container>
</template>
